import PurchaseOrderProgressBar from '../../../purchase-order-progress-bar';
import styles from './styles.module.less';

export const ReceivedColumn = ({ data }) => {
  return (
    <div className={styles['received-column']}>
      <PurchaseOrderProgressBar
        receivedItems={data.totalReceived}
        rejectedItems={data.totalRejected}
        renderWithoutItemsCopy
        showDescription
        totalItems={data.totalOrdered}
      />
    </div>
  );
};
